var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dropdown-item",class:{ active: _vm.isActive },on:{"click":_vm.changeNetwork}},[_vm._v(" "+_vm._s(_vm._f("title")(_vm.network.type))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }